import { render, staticRenderFns } from "./SalesForceConnector.vue?vue&type=template&id=4d12200b&scoped=true&"
import script from "./SalesForceConnector.vue?vue&type=script&lang=js&"
export * from "./SalesForceConnector.vue?vue&type=script&lang=js&"
import style0 from "./SalesForceConnector.vue?vue&type=style&index=0&id=4d12200b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d12200b",
  null
  
)

export default component.exports